<template>
<v-dialog v-model="dialog" max-width="1000px">
	<v-card class="elevation-12">
		<v-toolbar
			color="primary"
			dark
			flat>
			<v-toolbar-title>Enroll Student</v-toolbar-title>
		</v-toolbar>
		<v-card-text>
			<Preloader text="Loading" v-if="loading" />

      <h4 class="mt-4 mb-2 text-center">Check the table below for existing enrollment of this applicant.</h4>
      
      <v-data-table
        :headers="headers"
        :items="redundants"
        :loading="loading"
        :hide-default-footer="true">

        <template v-slot:item._course="{ item }">
          {{ item['course.shortTitle'] || item['course.title'] }}
        </template>
        
				<template v-slot:no-data>
					This student is not enrolled to any course(s) yet.
				</template> 
      </v-data-table>
      
      <div v-if="!loading && registration">
        <v-row>
          <v-col cols="12" md="4">
            <v-text-field
              label="Firstname"
              prepend-icon="mdi-account"
              v-model="registration.firstname"
              readonly/>
          </v-col>
          <v-col cols="12" md="4">
            <v-text-field 
              v-model="registration.middlename" 
              prepend-icon="mdi-account"
              label="Middlename"
              readonly=""/>
          </v-col>
          <v-col cols="12" md="4">
            <v-text-field 
              v-model="registration.lastname" 
              prepend-icon="mdi-account"
              label="Lastname"
              readonly/>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12" md="4">
            <v-text-field
              label="Birthdate"
              prepend-icon="mdi-calendar"
              v-model="registration.birthdate"
              readonly/>
          </v-col>
          <v-col cols="12" md="4">
            <v-text-field
              label="Email"
              prepend-icon="mdi-email"
              v-model="registration.email"
              readonly/>
          </v-col>
          <v-col cols="12" md="4">
            <v-text-field
              label="Mobile"
              prepend-icon="mdi-phone"
              v-model="registration.mobile"
              readonly/>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12">
            <v-text-field
              label="Address"
              prepend-icon="mdi-map-marker"
              v-model="registration.address"
              readonly/>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12">
            <v-text-field
              label="In case of rejection, specify reason below:"
              placeholder="Reason"
              prepend-icon="mdi-close"
              hint="Ex. Invalid Identification Card"
              v-model="registration.remarks"/>
          </v-col>
        </v-row>
      </div>
		</v-card-text>
		<v-card-actions>
			<v-btn 
				color="red" dark
				@click="reject()"
				v-show="!loading">
				Reject
			</v-btn>
			<v-spacer />
			<v-btn 
				@click="dialog = false">
				Close
			</v-btn>
			<v-btn 
				color="primary" dark
				@click="enroll()"
				v-show="!loading">
				Enroll
			</v-btn>

		</v-card-actions>
		</v-card>
	
</v-dialog> 
</template>
<script>
import Auth from '../../services/auth'
import Api from '../../services/api'
// import Constants from '../../services/constants'
import Notify from '../../services/notify'
import Preloader from '../main/Preloader'

export default {
  name: 'ApprovalForm',
  components: { Preloader },
  data() {
    return {
      loading: false,
      dialog: false,
      registration: null, 
      redundants: [],
      headers: [
        { text: 'Lastname', value: 'lastname', sortable: false },
        { text: 'Firstname', value: 'firstname', sortable: false },
        { text: 'Middlename', value: 'middlename', sortable: false },
        { text: 'Email', value: 'email', sortable: false },
        { text: 'Mobile', value: 'mobile', sortable: false },
        { text: 'Address', value: '_address', sortable: false },
        { text: 'Course', value: '_course', sortable: false },
        { text: 'Enrolled On', value: 'enrollDateTime', sortable: false },
      ],
    }
  },
  methods: {
    init(registration) {
      this.dialog = true;
      this.loading = true;
      Api.registration.get(registration.id)
        .then((response) => {
          this.registration = response.data;
          this.registration.address = 
            this.registration.province + ', ' +
            this.registration.city + ', ' +
            this.registration.street;
          this.redundancyCheck(this.registration);
            
        })
        .finally(() => { this.loading = false; });
    },

    redundancyCheck(registration) {
      this.loading = true;
      Api.registration.searchEnrolled(registration.firstname, registration.lastname)
        .then((response) => {
          this.redundants = response.data;
        })
        .finally(() => { this.loading = false });
    },

    enroll() {
      Notify.confirm('Enroll Student?', "This will notify the applicant through email. Be sure to check if the student is not yet enrolled to any courses.")
        .then(() => {
          this.loading = true;
          Api.registration.enroll(
            this.registration.id,
            Auth.getLoggedUser().id
          )
            .then(() => {
              Notify.toast('Student Enrolled!');
              this.$emit('registration-enrolled');
            })
            .catch(() => {
              Notify.toast('Oops, Something went wrong..');
            })
            .finally(() => {
              this.dialog = false;
              this.loading = false;
            });
        })
        .catch(() => {});
    },

    reject() {
      if(!this.registration.remarks) {
        Notify.toast('Specify reason first');
        return;
      }

      Notify.confirm('Reject Registration?', "This will notify the applicant through email.")
        .then(() => {
        this.loading = true;
          Api.registration.reject(
              this.registration.id,
              Auth.getLoggedUser().id,
              this.registration.remarks
            )
            .then(() => {
              this.loading = false;
              this.dialog = false;
              Notify.toast('Application rejected');
              this.$emit('registration-rejected');
            });
        }).catch(() => {});
    },

  }
}
</script>